import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const AppBtnMenuSmall = ({
	onclick,
	icon,
	selected,
	value,
	title = "",
	completed = false,
	extraClasses = "",
	disabled = false,
}) => {
	return (
		<button
			className={`app-btn-menu-small ${extraClasses} ${completed && "completed"} ${selected && "selected"}`}
			type={"button"}
			onClick={() => onclick(value)}
			disabled={disabled}
		>
			{title !== "" ? title : <FontAwesomeIcon icon={icon} />}
		</button>
	)
}

export default AppBtnMenuSmall
